import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBullseye,
    faEarthAmericas,
    faGaugeHigh,
    faLanguage,
    faMagicWandSparkles,
    faShieldHalved
} from "@fortawesome/free-solid-svg-icons";
import {Link} from "@inertiajs/react";
import useTranslations from "@/hooks/useTranslations";
import HeroAnimation from "@/Pages/Home/Partials/HeroAnimation";

export default function () {
    const { __, isRtl } = useTranslations();

    return (
        <div className="container mx-auto px-5" dir={isRtl ? 'rtl' : 'ltr'}>
            <main className="grid lg:grid-cols-2 items-center pt-16 pb-0 md:pt-12 md:pb-10 ">
                <div className="py-10 md:py-6 order-1 flex w-full justify-center lg:justify-end lg:pe-12">
                    <HeroAnimation label={__('home.hero.img_alt')} frameSrc="/img/frame.webp"/>
                </div>
                <div className="flex flex-col items-center lg:flex-initial lg:items-start text-center lg:text-start">
                    <h1 className="text-4xl lg:text-5xl 2xl:text-6xl font-bold lg:tracking-tight xl:tracking-tighter text-gray-900 dark:text-gray-100">
                        {__('home.hero.title')}
                    </h1>
                    <p className="text-lg mt-4 text-slate-600 dark:text-slate-400 max-w-xl">
                        {__('home.hero.subtitle')}
                    </p>
                    <div className="mt-6 flex flex-col gap-3 ">
                        <a
                            className="rounded text-lg text-gray-900 w-fit transition focus-visible:ring-2 ring-offset-2 ring-gray-200 px-5 py-2.5  hover:bg-gray-500 hover:text-white  border-2 border-gray-500 inline-flex  gap-1 items-center "
                            href={route('auth.redirect')}>
                            <svg className="w-4 h-4 me-2" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 48 48"
                                 style={{display: 'block'}}>
                                <path fill="#EA4335"
                                      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                                <path fill="#4285F4"
                                      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                                <path fill="#FBBC05"
                                      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                                <path fill="#34A853"
                                      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                                <path fill="none" d="M0 0h48v48H0z"></path>
                            </svg>
                            <span className="whitespace-nowrap">{__('home.hero.cta_primary')}</span>
                        </a>

                        <Link
                            className="w-fit underline inline-block mx-auto lg:mx-0"
                            href={route('register')}>{__('home.hero.cta_secondary')}</Link>

                    </div>
                </div>
            </main>
            <hr className="pt-5 md:pt-10 dark:border-gray-700"/>
            <div className="mt-5 md:mt-16 md:mt-0"><h2
                className="md:text-4xl lg:text-3xl text-lg font-bold lg:tracking-tight text-gray-900 dark:text-gray-100">
                {__('home.section.title')}
            </h2> <p className="text-lg mt-4 text-slate-600 dark:text-slate-400">
                {__('home.section.subtitle')}
            </p></div>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 mt-16 gap-16">
                <div className="flex gap-4 items-start">
                    <div className="mt-1rounded-full pt-2">
                        <FontAwesomeIcon className="text-orange-500" size="2xl" icon={faBullseye}/>
                    </div>
                    <div><h3 className="font-semibold text-lg text-gray-900 dark:text-gray-100">{__('home.features.accuracy.title')}</h3>  <p
                        className="text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">{__('home.features.accuracy.description')}</p></div>
                </div>
                <div className="flex gap-4 items-start">
                    <div className="mt-1rounded-full pt-2">
                        <FontAwesomeIcon className="text-orange-500" size="2xl" icon={faMagicWandSparkles}/>
                    </div>
                    <div><h3 className="font-semibold text-lg text-gray-900 dark:text-gray-100">{__('home.features.automation.title')}</h3>  <p
                        className="text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">{__('home.features.automation.description')}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-start">
                    <div className="mt-1rounded-full pt-2">
                        <FontAwesomeIcon className="text-orange-500" size="2xl" icon={faEarthAmericas}/>
                    </div>
                    <div><h3 className="font-semibold text-lg text-gray-900 dark:text-gray-100">{__('home.features.languages.title')}</h3>  <p
                        className="text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">{__('home.features.languages.description')}</p></div>
                </div>
                <div className="flex gap-4 items-start">
                    <FontAwesomeIcon className="text-orange-500" size="2xl" icon={faGaugeHigh}/>
                    <div><h3 className="font-semibold text-lg text-gray-900 dark:text-gray-100">{__('home.features.speed.title')}</h3>  <p
                        className="text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">{__('home.features.speed.description')}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-start">
                    <div className="mt-1rounded-full pt-2">
                        <FontAwesomeIcon className="text-orange-500" size="2xl" icon={faLanguage}/>
                    </div>
                    <div><h3 className="font-semibold text-lg text-gray-900 dark:text-gray-100">{__('home.features.translation.title')}</h3>  <p
                        className="text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">{__('home.features.translation.description')}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-start">
                    <div className="mt-1rounded-full pt-2">
                        <FontAwesomeIcon className="text-orange-500" size="2xl" icon={faShieldHalved}/>
                    </div>
                    <div><h3 className="font-semibold text-lg text-gray-900 dark:text-gray-100">{__('home.features.privacy.title')}</h3>  <p
                        className="text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">{__('home.features.privacy.description')}</p></div>
                </div>
            </div>

        </div>
    )
}
